.maintenance-windows-container {
  display: flex;

  gz-button {
    margin-left: calc(var(--spacer) * 2);
  }
}

gz-info-box {
  padding: calc(var(--spacer) * 2) 0;
}

gz-dropdown {
  --form-field-input-width: 400px;
}
